export default __webpack_public_path__ + "static/ng-f6b0d4bf07e5edc95f644dd30fbb3835.svg";